import React from 'react'
import { useEffect } from 'react';
import { logout } from '../../utils/auth';
import { Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const Toast = Swal.mixin({
    toast:true,
    position:"top",
    showConfirmButton:false,
    timer:3000,
    timerProgressBar: true

})

function Logout() {
    const navigate = useNavigate()

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);

    useEffect(() => {
        logout()
        Toast.fire({
            icon:"success",
            title:"Logout Successful"
        })
        navigate("/login")
    }, [])

  return (
    <>
    </>
    
  )
}

export default Logout